import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'trim'
})
export class TrimPipe implements PipeTransform {

	public transform(value: any): any {
		if (!value) {
			return '';
		}
		return value.toString()
			.replace(/^(&nbsp;)+/, '')
			.replace(/(&nbsp;)+$/, '')
			.trim();
	}

}
